<template>
  <Chips 
    class="qmkey-header-filter-chips"
    :key="'ExplorerFilterChips_'+forceRender"
    :title="$vuetify.lang.translator('filters.advanced.filters')+': '"
    :items="filters_chips"
    :whitelist="whitelist_filters_chips"
    :disable="disable"
    @update="update_filters"
  />
</template>
  
<style lang="scss">
  @import '@/sass/explorer.scss';
  .qmkey-header-filter-chips {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
</style>
  
<script>
  import { QFilters } from '@/qunit/filters';
  import Chips from '@/components/explorer/chips/Chips';
import { get_qfilter } from '../../qunit/filters';
  
  export default {
    name: 'FiltersChips',
  
    props: {
      filters: {
        type: QFilters,
        required: true,
      },
      disable: {
        type: Boolean,
        default: false,
      },
    },
  
    components: {
      Chips
    },
  
    data: () => ({
      forceRender: 0,
      whitelist_filters_chips: [
        'process_id',
        'processes_ids',
        'search',
        'advanced_filters',
        'date_fields',
        'date_range',
        'filter_dates',
        'current_workflow_responsible',
      ],
    }),
  
    computed: {
      filters_chips() {
        let items = {}
        if(this.filters) {
          for (const key of this.whitelist_filters_chips) {
            const filter = this.filters.get_filter(key);
            if (filter) {
              items[key] = filter.chip_object();
            }
          }
        }
        return items;
      },
    },
  
    methods: {
      update_filters(chip_filter) {
        let filters = new QFilters(this.filters);
        if (!chip_filter.parent) {
          filters.set_filter(get_qfilter(chip_filter.name,null),true);
        } else {
          let filter_value = this.filters.get_filter_value(chip_filter.parent) || {};
          delete filter_value[chip_filter.name]
          filters.set_filter(get_qfilter(chip_filter.parent,filter_value));
        }
        this.$emit('update',filters);
        //this.$emit('update');
      },
    },
    watch: {
      filters_chips() {
        this.forceRender ++;
        if (this.forceRender > 1) {
          this.forceRender = 0;
        }
      }
    },
  }  
</script>
  